import React, { useContext } from 'react'

import UntypedToastsWrapper from 'components/Toasts'

import ToastContext from '../ToastManager/ToastContext'
import Toast from './Toast'

const ToastsWrapper = UntypedToastsWrapper as any
const MAX_VISIBLE_TOASTS = 2

interface ToastsProps {
  className?: string
  maxVisibleToasts?: number
}

const Toasts: React.FC<ToastsProps> = props => {
  const {
    className,
    maxVisibleToasts = MAX_VISIBLE_TOASTS,
  }: typeof props = props
  const { dismissToast, toasts } = useContext(ToastContext)

  // Prevent showing more then the "maxVisibleToasts" at the time
  const initialToasts = toasts.slice(-maxVisibleToasts)

  return (
    <ToastsWrapper className={className}>
      {initialToasts.map(toast => (
        <Toast
          key={toast.id}
          id={toast.id}
          variant={toast.variant}
          autoDismiss={toast.autoDismiss}
          onDismiss={() => dismissToast(toast.id)}>
          {toast.message}
        </Toast>
      ))}
    </ToastsWrapper>
  )
}

export default Toasts
